import $ from 'jquery';
import KakaoTVPlayer from './kakaotv-player';
import * as events from './events';
import defaultConfigs from './default-configs';

export default $.extend(
  KakaoTVPlayer,
  {
    events,
    create(configs) {
      return new KakaoTVPlayer($.extend({}, defaultConfigs, configs));
    }
  }
);


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/kakaotv-url-player/index.js
 **/